import {ProcessStage} from '@hconnect/common'

export const mapProcessStage = (value: Map<string, string>): ProcessStage[] =>
  Array.from(value, ([code, name]) => ({code, name}))
